export var getAppConfig = function (state) { return state.appConfig; };
export var getProfileData = function (state) { return state.profileData; };
export var getAuthorizationData = function (state) {
    return state.authorizationReducer;
};
export var getAlertsData = function (state) { return state.alertsData; };
export var getPurchaseExceedsValue = function (state) { var _a, _b; return (_b = (_a = state.alertsData.byId.PURCHASE_EXCEEDS) === null || _a === void 0 ? void 0 : _a.attributes[0]) === null || _b === void 0 ? void 0 : _b.value; };
export var getPurchaseExceedsKey = function (state) { var _a, _b; return (_b = (_a = state.alertsData.byId) === null || _a === void 0 ? void 0 : _a.PURCHASE_EXCEEDS) === null || _b === void 0 ? void 0 : _b.attributes[0].key; };
export var getAlertsDataByID = function (id) {
    return function (state) { return state.alertsData.byId[id]; };
};
export var getHasAcknowledgeTermsConditions = function (state) {
    return state.alertsData.hasAcknowledgeTermsConditions;
};
export var getPurchaseExceedsIsDirty = function (state) { var _a; return (_a = state.alertsForm.PURCHASE_EXCEEDS) === null || _a === void 0 ? void 0 : _a.isDirty; };
export var getPurchaseExceedsDataErrors = function (state) { var _a, _b; return (_b = (_a = state.alertsForm) === null || _a === void 0 ? void 0 : _a.PURCHASE_EXCEEDS) === null || _b === void 0 ? void 0 : _b.dataErrors; };
export var getPurchaseExceedsThresholdAmount = function (state) {
    return state.alertsForm.PURCHASE_EXCEEDS.attributes.purchaseExceedsThresholdAmount
        .value;
};
export var getPurchaseExceedsErrorByKey = function (key) {
    return function (state) {
        var _a;
        return ((_a = state.alertsForm.PURCHASE_EXCEEDS.dataErrors.find(function (error) { return error.key === key; })) === null || _a === void 0 ? void 0 : _a.value) || '';
    };
};
export var getAlertFormDataByID = function (id) {
    return function (state) { return state.alertsForm[id]; };
};
